import { render, staticRenderFns } from "./ExpressPoshtaReportTableMobile.vue?vue&type=template&id=38995804&scoped=true"
import script from "./ExpressPoshtaReportTableMobile.vue?vue&type=script&lang=js"
export * from "./ExpressPoshtaReportTableMobile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38995804",
  null
  
)

export default component.exports